var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nuxt-link',{attrs:{"to":_vm.link}},[_c('ContentTag',{attrs:{"tag-text":_vm.tagText,"article":_vm.article,"background-color":_vm.backgroundColor,"foreground-color":_vm.foregroundColor,"font-smaller":_vm.fontSmaller,"font-weight-bold":_vm.fontWeightBold,"rounded-pill":_vm.roundedPill}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }